// extracted by mini-css-extract-plugin
export var errorsContainer = "_v9-1";
export var link = "_v9-0";